import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SymptomsChecklist } from '../components/SymptomsChecklist';
import { EmotionalAnchor } from '../components/EmotionalAnchor';
import { WhyMedicineFails } from '../components/WhyMedicineFails';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { ProductIntroduction } from '../components/ProductIntroduction';
import { BonusStack } from '../components/BonusStack';
import { ValueStackTable } from '../components/ValueStackTable';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { UrgencyBlock } from '../components/UrgencyBlock';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export const LandingPage = () => {
  return <>
      <AnnouncementBar data-id="element-293" />
      <HeroSection data-id="element-294" />
      <StorySection data-id="element-295" />
      <SymptomsChecklist data-id="element-296" />
      <EmotionalAnchor data-id="element-297" />
      <WhyMedicineFails data-id="element-298" />
      <UniqueMechanism data-id="element-299" />
      <ProductIntroduction data-id="element-300" />
      <BonusStack data-id="element-301" />
      <ValueStackTable data-id="element-302" />
      <Testimonials data-id="element-303" />
      <Guarantee data-id="element-304" />
      <UrgencyBlock data-id="element-305" />
      <FinalCTA data-id="element-306" />
      <FAQ data-id="element-307" />
      <Footer data-id="element-308" />
    </>;
};